import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../shared/components/Sifra';
import { icons } from '../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import Indicator from '../../../UI/Indicator/Indicator';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';
import './grid.css';

const GridProvider = ({
  data = [],
  handleRadniNalog,
  isLoading,
  handleClickDokument,
  handlePonuda,
  handleOpenZakljuci,
  onSearchChange,
  savedFilter,
  handleRokZavrsetka,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleRadniNalog={() => handleRadniNalog(e.row)}
          handlePonuda={() => handlePonuda(e.row)}
          handleOpenZakljuci={() => handleOpenZakljuci(e.row)}
          handleRokZavrsetka={() => handleRokZavrsetka(e.row)}
          // disableZakljuci={e.row.status === 'Završen'}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    {
      field: '',
      disableExport: true,
      headerName: '',
      width: 20,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <div style={{ position: 'relative', height: '20px', width: '20px' }}>
          <Indicator status={e.row.statusMasine} inGrid />
        </div>
      ),
    },
    // { field: 'ceoBrDok', headerName: 'Broj dok.', width: 80 },
    {
      field: 'ceoBrDok',
      headerName: t('docNumber'),
      width: 90,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickDokument(e.row)}
          fontWeight={
            localStorage.getItem('idFirme') !== '1'
              ? '600'
              : e.row.procitano
              ? '100'
              : '600'
          }
        />
      ),
    },
    { field: 'sifra', headerName: t('robot/mold'), width: 100 },
    { field: 'oznakaKupca', headerName: t('internTag'), width: 100 },
    // { field: 'serijskiBroj', headerName: 'Serijski broj', width: 120 },
    ...(localStorage.idFirme === '1'
      ? [
          {
            field: 'NazivFirmeKorisnikaPrograma',
            headerName: t('client'),
            width: 160,
          },
        ]
      : []),
    // {
    //   field: 'NazivFirmeKorisnikaPrograma',
    //   headerName: t('client'),
    //   width: 160,
    // },
    {
      field: 'imeKorisnikaSlanjaZahteva',
      headerName: t('reportedBy'),
      width: 150,
    },

    { field: 'vrsteKvarova', headerName: t('malfunctionType'), width: 250 },
    {
      field: 'status',
      headerName: t('requestStatus'),
      width: 130,
    },
    {
      field: 'datumSlanja',
      headerName: t('sentDate'),

      width: 110,
      renderCell: (e) => formatDateFromDB(e.row.datumSlanja),
    },

    {
      field: 'rokZavrsetka',
      headerName: t('rokZavrsetka'),
      width: 110,
      valueFormatter: ({ value }) => formatDateFromDB(value),
      cellClassName: (params) => {
        if (params.row.istekaoRok === 'predIstek') return 'cell-warning';
        if (params.row.istekaoRok === 'istekao') return 'cell-danger';
        return '';
      },
    },
    {
      field: 'datumZatvaranja',
      headerName: t('datumZatvaranja'),
      width: 110,
      valueFormatter: ({ value }) => formatDateFromDB(value),
    },
    {
      field: 'garancija',
      headerName: t('garancija'),
      width: 150,
    },
    { field: 'naslov', headerName: t('title'), width: 300 },
    // { field: 'statusMasine', headerName: 'Status mašine', width: 120 },
    // { field: 'imeKorisnikaSlanjaZahteva', headerName: 'Prijavio', width: 160 },

    // { field: 'sifra', headerName: 'Oznaka robota/alata', width: 160 },
    // {
    //   field: 'oznakaKupca',
    //   headerName: 'Interna oznaka robota/alata',
    //   width: 190,
    // },
  ];

  return (
    <div style={{ height: '74vh', width: '99%' }}>
      <MuiGrid
        data={data}
        columns={columns}
        loading={isLoading}
        onSearchChange={onSearchChange}
        savedFilter={savedFilter}
      />
    </div>
  );
};

export default GridProvider;
